import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { format } from 'date-fns';
import IconDelivery from '../../icons/icon-delivery.svg';
import { fetchExternalAddOnsAction, updateAddOnSelection, updateZipCode } from '../../redux/actions/externalAddOns';
import ExternalAddOns from './ExternalAddOns';


class ExternalAddOnsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.checkAndSubmitZipCode = this.checkAndSubmitZipCode.bind(this);
    this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
    this.timer = null;
  }

  componentDidMount() {
    const {
      error,
      submitZipCode,
      updateIsZipCodeSaved,
      zipCode,
    } = this.props;

    if (!error) {
      const shouldSaveZipCode = true;

      submitZipCode(zipCode, shouldSaveZipCode);
      updateIsZipCodeSaved(true);
    }
  }

  handleZipCodeChange(zipCode) {
    const {
      dispatch,
      getExternalAddOnsUrl,
      updateIsZipCodeSaved,
      isZipCodeSaved,
      id: productID
    } = this.props;
    const shouldSaveZipCode = false;

    if (isZipCodeSaved) {
      updateIsZipCodeSaved(false);
    }

    dispatch(
      updateZipCode(
        zipCode,
        () => ({ getExternalAddOnsUrl, id: productID }),
      )
    );

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      dispatch(fetchExternalAddOnsAction(zipCode, shouldSaveZipCode, () => ({ getExternalAddOnsUrl, id: productID })));
    }, 200);
  }

  componentDidUpdate(prevProps) {
    const {id: currentProductId } = this.props;
    const {id: prevProductId } = prevProps;

    if(currentProductId !== prevProductId) {
      const {
        error,
        submitZipCode,
        updateIsZipCodeSaved,
        zipCode,
      } = this.props;
      
      if (!error) {
        const shouldSaveZipCode = true;
  
        submitZipCode(zipCode, shouldSaveZipCode);
        updateIsZipCodeSaved(true);
      }
    }
  }

  checkAndSubmitZipCode() {
    if (!this.props.error) {
      const {
        submitZipCode,
        updateIsZipCodeSaved,
        zipCode,
      } = this.props;

      updateIsZipCodeSaved(true);
      const shouldSaveZipCode = true;

      submitZipCode(
        zipCode,
        shouldSaveZipCode,
        state => (state.product),
      );
    }
  }


  render() {
    const {
      externalAddOns,
      earliestDeliveryDate,
      dispatch,
      inFlight,
      getExternalAddOnsUrl,
      isZipCodeSaved,
      id: productID,
      error,
      errorMessage,
      zipCode,
    } = this.props;

    const zipCodeInputFieldClass = classNames({
      'externalAddOns__input_zipcode': true,
      'externalAddOns__input_zipcode--error': error,
    });

    return (
      <>
        <div className="externalAddOns externalAddOns--promo-tile">
          <div className="externalAddOns__header-container">
            <div className="externalAddOns__header">
              <span className="externalAddOns__header--label">
                <IconDelivery className="externalAddOns__header--icon" />
                Delivery
              </span>
              <div className="externalAddOns__header--subtext">
                <p>
                  Enter your zip code to estimate delivery and find out available
                  add-on services.
                </p>
                <p>You can select your preferred delivery date at checkout.</p>
              </div>
            </div>
            <div className="externalAddOns__content">
              <fieldset className="zip-code__input-container">
                <input
                  type="number"
                  name="zipcode"
                  id="zipcode"
                  value={zipCode}
                  autoFocus
                  className={zipCodeInputFieldClass}
                  onChange={(event) => {
                    this.handleZipCodeChange(event.target.value);
                  }}
                />
                <label htmlFor="zipcode" aria-labelledby="zipcode">Zip Code</label>
              </fieldset>
              <button
                className="externalAddOns__zip-code-save"
                type="button"
                value="Save"
                disabled={error}
                onClick={() => this.checkAndSubmitZipCode()}
              >
                Save
              </button>
            </div>
            <div className="externalAddOns__header-info-container">
              {error && (
                <span className="externalAddOns__zip-code__input-error">{errorMessage}</span>
              )}
              {
                earliestDeliveryDate && (
                  <div className="externalAddOns__delivery-date">
                    <input type="hidden" name="earliestDeliveryDate" value={format(new Date(earliestDeliveryDate), 'yyyy-MM-dd')} />
                    <span>{`Earliest possible delivery for ${zipCode} is `}</span>
                    <span className="externalAddOns__product-delivery-date-date">{format(new Date(earliestDeliveryDate), 'MMM dd, yyyy')}</span>
                  </div>
                )
              }
            </div>
          </div>
          { externalAddOns && isZipCodeSaved &&
            <ExternalAddOns
              inFlight={inFlight}
              externalAddOns={externalAddOns}
              updateAddOnSelection={(addOnId, selected) => {
                dispatch(updateAddOnSelection(addOnId, selected, () => ({getExternalAddOnsUrl, id: productID})))
              }} />
          }
        </div>
      </>
    );
  }
}

ExternalAddOnsContainer.propTypes = {
  error: PropTypes.bool,
  nonDeliverable: PropTypes.bool,
  prevZipCode: PropTypes.string,
  dateOfDelivery: PropTypes.string,
  zipCode: PropTypes.string,
  zipSubmitButton: PropTypes.func,
  updateZip: PropTypes.func,
  updateIsZipCodeSaved: PropTypes.func.isRequired,
  submitZipCode: PropTypes.func.isRequired,
  isZipCodeSaved: PropTypes.bool.isRequired,
};

export default ExternalAddOnsContainer;
